<template>
	<div>
		<div class="d-flex align-items-center min-height-70vh" >
			<div class="container d-flex justify-content-center">
				<div class="card my-4 border-radius-8 max-width-800">
					<div class="card-header text-bold">
						<div class="text-center">
							<div class="card-headline">Konfirmasi Pembayaran</div>
						</div>
					</div>
					<div class="card-body">
						<div class="text-center mb-2">
							<div class="mb-2">
								<div>Terima kasih telah melakukan konfirmasi pembayaran</div>
								<div>Order anda akan segera kami proses</div>
							</div>
							<router-link to="/wholesale-order">
								<button
									class="btn btn-primary mt-2"
								>
									{{ $t('Back to Catalog') }}
								</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<main-footer />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainFooter from '@/components/homepages/Footer.vue';

export default {
	components: {
		MainFooter,
	},
	methods: {
		checkFeature() {
			if (this.user) {
				const isAllowed = this.isDropshipper;
				if (!isAllowed) {
					this.$router.replace('/');
				}
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
		}),
	},
	watch: {
		user() {
			this.checkFeature();
		},
	},
	mounted() {
		this.checkFeature();
	},
};
</script>
